export default __webpack_public_path__ + "static/media/sonia.c1ed9ca7.jpg";